import React from 'react';
import PropTypes from 'prop-types';
import styles from './CountsPopup.module.scss';
import { getText } from '../../../i18n';

const CountsPopup = ({ x, y, onClose, counts }) => {
    const modalStyle = {
        top: y - 60,
        left: x,
        width: '305px',
        position: 'absolute',
        backgroundColor: 'white',
        border: '1px solid #ccc',
        zIndex: 1000,
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
        padding: '40px 40px 30px',
    };

    const statusStyles = {
        Active: 'active',
        'Leave of Absence': 'leave',
        Terminated: 'terminated',
        Retiree: 'retiree',
        COBRA: 'cobra',
        Contractor: 'contractor',
    };

    const getTypeClass = type => {
        switch (type) {
            case 'Active':
                return 'ing-badge-active';
            case 'Leave of Absence':
                return 'ing-badge-in-progress';
            case 'Terminated':
                return 'ing-badge-error';
            default:
                return 'ing-badge-inactive';
        }
    };

    const total = counts.reduce((sum, item) => sum + item.count, 0);

    return (
        <div style={modalStyle} className={styles.popupModal}>
            <button onClick={onClose} className={styles.closeButton}>
                <i className="bi bi-x"></i>
            </button>
            <div className={styles.content}>
                {counts.map(item => (
                    <div key={item.status} className={styles.item}>
                        {/*<span className={`${styles.label} ${styles[statusStyles[item.status]]}`}>
                            {item.status}
                        </span>*/}
                        <button className={getTypeClass(item.status)}>
                            {item.status}
                        </button>
                        <span className={styles.value}>{item.count}</span>
                    </div>
                ))}
                <div className={styles.total}>
                    <span style={{ marginRight: '10px' }}>{getText('msg_b25928c69902')}</span>
                    <span>{total}</span>
                </div>
            </div>
        </div>
    );
};

CountsPopup.propTypes = {
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired,
    counts: PropTypes.arrayOf(
        PropTypes.shape({
            count: PropTypes.number.isRequired,
            status: PropTypes.string.isRequired,
        }),
    ).isRequired,
};

export default CountsPopup;
